var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.055,
    height: 102.941,
    viewBox: "0 0 104.055 102.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-1-svgrepo-com",
    d: "M28.889,88.108A24.889,24.889,0,0,0,4,113v12.444h99.555V113A24.889,24.889,0,0,0,78.666,88.108H53.777m0-61.108A24.877,24.877,0,1,0,75.337,39.444",
    transform: "translate(-1.75 -24.75)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.5,
    opacity: 0.072
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgetIcon);
export default __webpack_public_path__ + "static/media/forget-icon.177d5fcbfd018df337f80181e38679d1.svg";
export { ForwardRef as ReactComponent };